import React from 'react';

import View from './view';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {formatSnils, formatOMS} from '../../../../../shared/pipes';
import {useStyles} from '../../../../../shared/hooks/styles';
import {datePipe} from '../../../../../shared/pipes/date';
import {Text} from '../../../../../shared/components/text';
import {passportNumberPipe} from '../../../../../shared/pipes/passportNumber';
import {maskPrivateData, PrivateDataMaskType} from '../../../../../shared/pipes/maskPrivateData';
import {EvenOddListItemContentFactoryProps} from '../../../../../shared/components/evenOddList';

export const ProfileUserDocuments = () => {
  const styles = useStyles(({theme}) => {
    return {
      prop: {
        textAlign: 'right',
        maxWidth: '65%',
        ...theme.fonts.body,
        color: theme.color.textColor,
        opacity: 1,
      },
      lbl: {
        ...theme.fonts.label,
      },
      label: {
        ...theme.fonts.body,
        color: theme.color.labelText,
        maxWidth: '38%',
      },
    };
  });

  const profile = useSelector(holderProfileSelector());

  if (!profile) {
    return null;
  }

  const passportInfo = [
    profile?.passport?.num
      ? {
          value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
            <>
              <Text testID='passport-num-title-id' style={styles.label}>
                Серия и номер
              </Text>
              <Text testID='passport-num-value-id' style={styles.prop}>
                {isMasked
                  ? maskPrivateData(passportNumberPipe(profile?.passport?.num), {
                      maskType: PrivateDataMaskType.digits,
                    })
                  : passportNumberPipe(profile?.passport?.num)}
              </Text>
            </>
          ),
        }
      : null,
    profile?.passport?.date
      ? {
          value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
            <>
              <Text testID='passport-date-label-id' style={styles.label}>
                Дата выдачи
              </Text>
              <Text testID='passport-date-value-id' style={styles.prop}>
                {isMasked
                  ? maskPrivateData(datePipe(profile?.passport?.date), {
                      maskType: PrivateDataMaskType.digits,
                    })
                  : datePipe(profile?.passport?.date)}
              </Text>
            </>
          ),
        }
      : null,
    profile?.passport?.org
      ? {
          value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
            <>
              <Text testID='passport-org-label-id' style={styles.label}>
                Кем выдан
              </Text>
              <Text testID='passport-org-valeu-id' style={[styles.prop]}>
                {isMasked ? maskPrivateData(profile?.passport?.org) : profile?.passport?.org}
              </Text>
            </>
          ),
        }
      : null,
  ].filter((item) => !!item);

  const documentsInfo = [
    profile?.snils
      ? {
          value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
            <>
              <Text testID='snils-label-id' style={styles.label}>
                СНИЛС
              </Text>
              <Text testID='snils-value-id' style={[styles.prop, {maxWidth: 'auto'}]} numberOfLines={1}>
                {isMasked
                  ? maskPrivateData(formatSnils(profile.snils), {
                      maskType: PrivateDataMaskType.digits,
                    })
                  : formatSnils(profile.snils)}
              </Text>
            </>
          ),
        }
      : null,
    profile?.oms
      ? {
          value: ({isMasked}: EvenOddListItemContentFactoryProps) => (
            <>
              <Text testID='oms-label-id' style={styles.label}>
                Полис ОМС
              </Text>
              <Text testID='oms-value-id' style={styles.prop}>
                {isMasked
                  ? maskPrivateData(formatOMS(profile.oms), {
                      maskType: PrivateDataMaskType.digits,
                    })
                  : formatOMS(profile.oms)}
              </Text>
            </>
          ),
        }
      : null,
  ].filter((item) => !!item);

  return <View documentsInfo={documentsInfo} passportInfo={passportInfo} />;
};
